import React from 'react'
import MissingDocumentsComponent from '../../components/MissingDocumentsComponent'

function MissingDocuments() {
  return <MissingDocumentsComponent />
}

export default MissingDocuments
